import useOffer from 'hooks/Offers/useOffer'
import usePropertyOfferMapping from 'hooks/Offers/usePropertyOfferMapping'
import useBedbankPackageViews from 'hooks/useBedbankPackageViews'
import { useMemo } from 'react'

type Return = [
  bedbankPackageViews: Array<App.BedbankOfferPackageView>,
  fetching: boolean,
]

function usePropertyBedbankViews(propertyId: string): Return {
  // Get the mapping for this property page so we know what bedbank offer to fetch
  const [mapping] = usePropertyOfferMapping(propertyId)
  // Get the bedbank offer for this property mapping
  const [bedbankOffer] = useOffer<App.BedbankOffer>(mapping?.bedbankOfferId)
  const [bedbankPackageViews, fetchingBedbankViews] = useBedbankPackageViews(bedbankOffer)

  const propertyBedbankViews = useMemo(() => {
    const mappedBedbankRoomIds = new Set(Object.values(mapping?.rooms ?? {}).flatMap(room => room.bedbankRoomIds))
    return bedbankPackageViews.filter(view => mappedBedbankRoomIds.has(view.package.roomId))
  }, [bedbankPackageViews, mapping?.rooms])

  return [propertyBedbankViews, fetchingBedbankViews]
}

export default usePropertyBedbankViews
